//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register";

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/post-fake-profile";

//CALENDER
export const GET_EVENTS = "/events";
export const GET_CATEGORIES = "/categories";
export const GET_UPCOMMINGEVENT = "/upcommingevents";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";

//Chat
export const GET_DIRECT_CONTACT = "/chat";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "add/message";
export const GET_CHANNELS = "/channels";

//project list
export const GET_PROJECT_LIST = "/project/list";
//PRODUCTS
export const GET_PRODUCTS = "/products";
export const GET_ORDERS = "/orders";
export const GET_SELLERS = "/sellers";

//Task
export const GET_TASK_LIST = "/task-list";

//Crypto
export const GET_TRANSATION_LIST = "/transation-list";
export const GET_ORDRER_LIST = "/order-list";

//TicketsList
export const GET_TICKETS_LIST = "/tickets-list";

//Crm
export const GET_CONTACTS = "/crmcontacts";
export const GET_COMPANIES = "/companies";
export const GET_DEALS = "/deals";
export const GET_LEADS = "/leads";

//Invoice
export const GET_INVOICES = "/invoices";
export const GET_CUSTOMERS = "/customers";
